export default __webpack_public_path__ + "static/media/photo--lg--rene-1.dafb9961.jpg";